/* ───────────────────────────────────────────────────────────────────────
   Simulations℠ · /pages/gift — simulations-gift.js
   Ported from Claude Design handoff 2026-05-25.

   Mode/pane switching is FOUC-free via the inline script in sim-gift.liquid
   (sets data-gift-mode) + CSS (shows the matching [data-gift-pane]).
   This file wires the per-pane behaviour:
     PERSONAL · add/remove recipients · live subtotal · CTA gating · bulk nudge
     BULK/COMPANY · live volume ↔ total ↔ bearer-count echo · contact prefill
   POST is stubbed for every mode until the Worker (Step 9).
   ─────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var shell = document.querySelector('.sim-gift-shell');
  if (!shell) return;

  // Unit price + currency come from Liquid (the live Pastlife variant in the
  // visitor's presentment currency). Totals format per-currency via Intl, so an
  // AU buyer sees A$, a US buyer $, etc. — never a hardcoded symbol.
  var UNIT = (parseInt(shell.getAttribute('data-gift-cents'), 10) || 30000) / 100;
  var CUR = shell.getAttribute('data-gift-currency') || 'USD';
  var MFMT; try { MFMT = new Intl.NumberFormat(undefined, { style: 'currency', currency: CUR, minimumFractionDigits: 0, maximumFractionDigits: 0 }); } catch (e) { MFMT = null; }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var BULK_PROMPT_AT = 25;

  function money(amount) { return MFMT ? MFMT.format(amount) : '$' + Math.round(amount).toLocaleString('en-US'); }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Parse a name,email,note CSV → accepted rows + per-line errors (B1).
  function parseCSV(text) {
    var lines = text.split(/\r?\n/);
    var rows = [], errors = [];
    var start = (lines[0] && /name\s*,\s*email/i.test(lines[0])) ? 1 : 0;
    for (var i = start; i < lines.length; i++) {
      var raw = lines[i];
      if (!raw || !raw.trim()) continue;
      var p = raw.split(',');
      var name = (p[0] || '').trim(), email = (p[1] || '').trim(), note = (p[2] || '').trim();
      if (!name && !email) continue;
      if (!name) errors.push({ line: i + 1, msg: 'missing name · ' + email });
      else if (!EMAIL_RE.test(email)) errors.push({ line: i + 1, msg: 'bad email “' + email + '”' });
      else rows.push({ name: name, email: email, note: note });
    }
    return { rows: rows, errors: errors };
  }

  // Render the parsed-CSV preview (B1) in place of the dropzone.
  function renderCsv(drop, fileName, parsed, fileInput) {
    var body = drop.parentNode;
    var prev = body.querySelector('.t-csv');
    if (prev) prev.parentNode.removeChild(prev);
    drop.style.display = 'none';
    var n = parsed.rows.length, e = parsed.errors.length;

    var html = '<div class="t-csv__head">' +
      '<p class="t-csv__file"><span class="t-csv__name">' + esc(fileName) + '</span> <span class="t-csv__tick">✓</span> ' +
      '<span class="t-csv__meta">' + n + ' rows' + (e ? ' · <strong>' + e + ' errors</strong>' : '') + '</span></p>' +
      '<p class="t-csv__file-actions"><a href="#" data-csv-replace>Replace</a><a href="#" data-csv-remove>Remove</a></p></div>' +
      '<ul class="t-csv__rows">';
    parsed.rows.slice(0, 3).forEach(function (r, i) {
      html += '<li class="t-csv__row"><span class="t-csv__num">' + (i + 1 < 10 ? '0' : '') + (i + 1) + '</span>' +
        '<span class="t-csv__name">' + esc(r.name) + '</span><span class="t-csv__email">' + esc(r.email) + '</span>' +
        '<span class="t-csv__note">' + (r.note ? '“' + esc(r.note) + '”' : '') + '</span></li>';
    });
    if (n > 3) html += '<li class="t-csv__ellipsis">… ' + (n - 3) + ' more</li>';
    parsed.errors.forEach(function (er) {
      html += '<li class="t-csv__row t-csv__row--err"><span class="t-csv__num">' + er.line + '</span>' +
        '<span class="t-csv__warn">' + esc(er.msg) + '</span></li>';
    });
    html += '</ul>';

    var csv = document.createElement('div');
    csv.className = 't-csv';
    csv.innerHTML = html;
    body.insertBefore(csv, drop.nextSibling);
    csv.querySelector('[data-csv-replace]').addEventListener('click', function (ev) { ev.preventDefault(); fileInput.click(); });
    csv.querySelector('[data-csv-remove]').addEventListener('click', function (ev) {
      ev.preventDefault(); fileInput.value = ''; csv.parentNode.removeChild(csv); drop.style.display = '';
      var p = drop.closest('[data-gift-pane]'); if (p) { p.__giftCsvRows = null; p.__giftCsvName = null; }   // clear stashed rows
      var fm = drop.closest('form'); if (fm) fm.dispatchEvent(new Event('input', { bubbles: true }));   // persist the clear
    });
  }

  /* ── PERSONAL pane ──────────────────────────────────────────────────── */
  var form = document.getElementById('gift-form');
  if (form) {
    var list = document.getElementById('recipient-list');
    var addBtn = document.getElementById('add-recipient');
    var subtotalEl = document.getElementById('gift-subtotal');
    var continueBtn = document.getElementById('gift-continue');
    var bulkPrompt = document.getElementById('bulk-prompt');

    var rows = function () { return list.querySelectorAll('[data-recipient-row]'); };

    // A row counts once it has a name AND a well-formed email.
    var filledCount = function () {
      var n = 0, rs = rows();
      for (var i = 0; i < rs.length; i++) {
        var name = rs[i].querySelector('input[name$="[name]"]');
        var email = rs[i].querySelector('input[name$="[email]"]');
        if (name && email && name.value.trim() && EMAIL_RE.test(email.value.trim())) n++;
      }
      return n;
    };
    var gifterReady = function () {
      var gn = document.getElementById('g-name'), ge = document.getElementById('g-email');
      return !!(gn && ge && gn.value.trim() && EMAIL_RE.test(ge.value.trim()));
    };

    var syncRemoveButtons = function () {
      var rs = rows(), multi = rs.length > 1;
      for (var i = 0; i < rs.length; i++) {
        var row = rs[i], btn = row.querySelector('.t-recipient__remove');
        if (multi && !btn) {
          row.classList.add('t-recipient--removable');
          btn = document.createElement('button');
          btn.type = 'button'; btn.className = 't-recipient__remove';
          btn.setAttribute('aria-label', 'Remove recipient'); btn.innerHTML = '&times;';
          btn.addEventListener('click', function (e) {
            var r = e.target.closest('[data-recipient-row]');
            if (r) { r.parentNode.removeChild(r); reindex(); refresh(); }
          });
          row.appendChild(btn);
        } else if (!multi && btn) {
          row.classList.remove('t-recipient--removable');
          btn.parentNode.removeChild(btn);
        }
      }
    };

    var reindex = function () {
      var rs = rows();
      for (var i = 0; i < rs.length; i++) {
        rs[i].setAttribute('data-recipient-row', i);
        var num = rs[i].querySelector('.t-rownum');
        if (num) num.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        var fields = rs[i].querySelectorAll('input');
        for (var j = 0; j < fields.length; j++) {
          var f = fields[j];
          var key = f.name.replace(/recipients\[\d+\]/, 'recipients[' + i + ']');
          f.name = key;
          var idKey = key.indexOf('[name]') > -1 ? 'name' : key.indexOf('[email]') > -1 ? 'email' : 'note';
          var lbl = rs[i].querySelector('label[for="' + f.id + '"]');
          f.id = 'r' + i + '-' + idKey;
          if (lbl) lbl.setAttribute('for', f.id);
        }
      }
    };

    var addRow = function () {
      var rs = rows();
      if (rs.length >= BULK_PROMPT_AT) return;   // Personal caps at 25 → Bulk handles 26+
      var tmpl = rs[0].cloneNode(true);
      var inputs = tmpl.querySelectorAll('input');
      for (var j = 0; j < inputs.length; j++) inputs[j].value = '';
      var existing = tmpl.querySelector('.t-recipient__remove');
      if (existing) existing.parentNode.removeChild(existing);
      list.appendChild(tmpl);
      reindex(); refresh();
      var first = tmpl.querySelector('input'); if (first) first.focus();
    };

    var refresh = function () {
      var n = filledCount();
      subtotalEl.textContent = money(n * UNIT);
      var ready = n >= 1 && gifterReady();
      continueBtn.disabled = !ready;
      continueBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      var rowCount = rows().length;
      if (bulkPrompt) bulkPrompt.hidden = rowCount < BULK_PROMPT_AT;
      if (addBtn) {
        var atMax = rowCount >= BULK_PROMPT_AT;
        addBtn.disabled = atMax;
        addBtn.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      }
      syncRemoveButtons();
    };

    if (addBtn) addBtn.addEventListener('click', addRow);
    form.addEventListener('input', refresh);
    form.addEventListener('change', refresh);   // browser autofill fires 'change'
    refresh();

    /* ── A4 validation → A5 review → A6 submitting ──────────────────── */
    var pane = form.closest('[data-gift-pane]');
    var review = document.getElementById('gift-review');
    var fieldOf = function (input) { return input.closest('.t-field'); };
    var clearError = function (fld) {
      if (!fld) return;
      fld.classList.remove('t-field--error');
      var e = fld.querySelector('.t-field__error');
      if (e) e.parentNode.removeChild(e);
    };
    var setError = function (fld, msg) {
      if (!fld) return;
      clearError(fld);
      fld.classList.add('t-field--error');
      var p = document.createElement('p');
      p.className = 't-field__error';
      p.textContent = msg;
      fld.appendChild(p);
    };

    var validate = function () {
      var ok = true, rs = rows(), seen = {};
      var gNameEl = document.getElementById('g-name');
      var gEmailEl = document.getElementById('g-email');
      var gEmail = (gEmailEl.value || '').trim().toLowerCase();
      for (var i = 0; i < rs.length; i++) {
        var nIn = rs[i].querySelector('input[name$="[name]"]');
        var eIn = rs[i].querySelector('input[name$="[email]"]');
        clearError(fieldOf(nIn)); clearError(fieldOf(eIn));
        var nV = nIn.value.trim(), eV = eIn.value.trim();
        if (i === 0 || nV || eV) {                       // row 1 required; extra rows required once touched
          if (!nV) { setError(fieldOf(nIn), 'Name required'); ok = false; }
          if (!eV) { setError(fieldOf(eIn), 'Email required'); ok = false; }
        }
        if (eV) {
          var key = eV.toLowerCase();
          if (!EMAIL_RE.test(eV)) { setError(fieldOf(eIn), 'Check this email'); ok = false; }
          else if (seen[key]) { setError(fieldOf(eIn), 'Duplicate recipient'); ok = false; }
          else if (gEmail && key === gEmail) { setError(fieldOf(eIn), 'This is your own email'); ok = false; }
          else seen[key] = true;
        }
      }
      clearError(fieldOf(gNameEl)); clearError(fieldOf(gEmailEl));
      if (!gNameEl.value.trim()) { setError(fieldOf(gNameEl), 'Your name required'); ok = false; }
      if (!gEmail) { setError(fieldOf(gEmailEl), 'Your email required'); ok = false; }
      else if (!EMAIL_RE.test(gEmail)) { setError(fieldOf(gEmailEl), 'Check your email'); ok = false; }
      return ok;
    };

    var buildReview = function () {
      if (!review) return;
      var rs = rows(), n = 0;
      review.querySelector('[data-rv-name]').textContent = document.getElementById('g-name').value.trim();
      review.querySelector('[data-rv-email]').textContent = document.getElementById('g-email').value.trim();
      var ul = review.querySelector('[data-rv-people]'); ul.innerHTML = '';
      for (var i = 0; i < rs.length; i++) {
        var nm = rs[i].querySelector('input[name$="[name]"]').value.trim();
        var em = rs[i].querySelector('input[name$="[email]"]').value.trim();
        var nt = rs[i].querySelector('input[name$="[note]"]').value.trim();
        if (!nm || !EMAIL_RE.test(em)) continue;
        n++;
        var li = document.createElement('li'); li.className = 't-people__row';
        var num = document.createElement('span'); num.className = 't-people__num'; num.setAttribute('aria-hidden', 'true'); num.textContent = (n < 10 ? '0' : '') + n;
        var body = document.createElement('div'); body.className = 't-people__body';
        var nmP = document.createElement('p'); nmP.className = 't-people__name'; nmP.textContent = nm;
        var ntP = document.createElement('p'); ntP.className = 't-people__note'; ntP.textContent = nt ? '“' + nt + '”' : '—';
        body.appendChild(nmP); body.appendChild(ntP);
        var emS = document.createElement('span'); emS.className = 't-people__email'; emS.textContent = em;
        li.appendChild(num); li.appendChild(body); li.appendChild(emS);
        ul.appendChild(li);
      }
      var total = n * UNIT;
      review.querySelector('[data-rv-count]').textContent = n;
      review.querySelector('[data-rv-sub]').textContent = money(total);
      review.querySelector('[data-rv-total]').textContent = money(total);
      review.querySelector('[data-rv-pay]').textContent = 'Pay ' + money(total);
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate()) {
        var fe = form.querySelector('.t-field--error');
        if (fe) fe.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      buildReview();
      pane.setAttribute('data-view', 'review');
      window.scrollTo(0, 0);                    // snap to top instantly — no footer flash
    });

    if (review) {
      var backBtn = review.querySelector('[data-rv-back]');
      if (backBtn) backBtn.addEventListener('click', function () {
        pane.setAttribute('data-view', 'form');
        window.scrollTo(0, 0);
      });
      review.addEventListener('submit', function (e) {
        e.preventDefault();                       // Worker (Step 9) POSTs /api/gift/initiate here
        pane.setAttribute('data-view', 'submitting');
        console.info('[gift] personal order ready — awaiting Worker (Step 9).');
      });
    }
  }

  /* ── BULK / COMPANY panes — live volume echo (scoped per pane) ──────── */
  var vols = shell.querySelectorAll('[data-volume]');
  for (var v = 0; v < vols.length; v++) {
    (function (input) {
      var pane = input.closest('[data-gift-pane]');
      var update = function () {
        var n = parseInt(input.value, 10) || 0;
        var total = pane.querySelector('[data-volume-total]');
        if (total) total.textContent = money(n * UNIT);
        var bearers = pane.querySelectorAll('[data-bearer-count]');
        for (var b = 0; b < bearers.length; b++) bearers[b].textContent = n;
      };
      input.addEventListener('input', update);
      input.addEventListener('change', update);
      update();
    })(vols[v]);
  }

  /* ── Company in-person nudge → contact with prefilled subject ───────── */
  var contactLinks = shell.querySelectorAll('[data-contact-link]');
  for (var c = 0; c < contactLinks.length; c++) {
    contactLinks[c].addEventListener('click', function (e) {
      var pane = e.currentTarget.closest('[data-gift-pane]');
      var co = pane && pane.querySelector('[data-company]');
      var name = co && co.value.trim();
      if (name) {
        e.preventDefault();
        var u = new URL(e.currentTarget.getAttribute('href'), location.origin);
        u.searchParams.set('subject', 'Institutional inquiry — ' + name);
        window.open(u.toString(), '_blank', 'noopener');
      }
    });
  }

  /* ── CSV dropzone — "choose file" picker + "Template ↓" download ────── */
  var drops = shell.querySelectorAll('.t-drop');
  for (var d = 0; d < drops.length; d++) {
    (function (drop) {
      var chooseBtn = drop.querySelector('.t-drop__btn');
      var tmplLink = drop.querySelector('.t-drop__meta a[download]');
      var lede = drop.querySelector('.t-drop__lede');
      var file = document.createElement('input');
      file.type = 'file'; file.accept = '.csv,text/csv'; file.style.display = 'none';
      drop.appendChild(file);

      if (chooseBtn) chooseBtn.addEventListener('click', function () { file.click(); });

      // Whole band is also a drop target.
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-dragover'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-dragover'); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault(); drop.classList.remove('is-dragover');
        if (e.dataTransfer && e.dataTransfer.files.length) { file.files = e.dataTransfer.files; show(); }
      });
      file.addEventListener('change', show);
      function show() {
        if (!(file.files && file.files[0])) return;
        var f = file.files[0];
        var reader = new FileReader();
        reader.onload = function () {
          var parsed = parseCSV(reader.result);
          var p = drop.closest('[data-gift-pane]'); if (p) { p.__giftCsvRows = parsed.rows; p.__giftCsvName = f.name; }  // stash for submit + carry-over
          renderCsv(drop, f.name, parsed, file);
          var fm = drop.closest('form'); if (fm) fm.dispatchEvent(new Event('input', { bubbles: true }));  // persist
        };
        reader.readAsText(f);
      }

      if (tmplLink) tmplLink.addEventListener('click', function (e) {
        e.preventDefault();
        var blob = new Blob(['name,email,note\nCasey Brooks,casey@example.com,Saw this. Thought of you.\n'], { type: 'text/csv' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; a.download = 'pastlife-gift-recipients-template.csv';
        document.body.appendChild(a); a.click();
        document.body.removeChild(a); URL.revokeObjectURL(url);
      });
    })(drops[d]);
  }

  /* Bulk / Company multi-step submit (setup → [mark] → review → invoice) is owned
     by simulations-gift-trust.js, which reads the CSV rows stashed above. */

  /* ── Bulk ↔ Company carry-over ──────────────────────────────────────────
     Bulk and Company are near-identical; switching between them is a full page
     reload, so a shared sessionStorage key carries volume · delivery · payment ·
     from · and the parsed CSV across the switch (and across a refresh). */
  (function () {
    var BC_KEY = 'simgift:bc:v1';
    var mode = shell.getAttribute('data-gift-mode');
    if (mode !== 'bulk' && mode !== 'company') return;
    var pane = shell.querySelector('[data-gift-pane="' + mode + '"]');
    var bcForm = pane && pane.querySelector('#gift-form-' + mode);
    if (!bcForm) return;
    var pfx = mode === 'bulk' ? 'b' : 'c';
    var fld = function (id) { return pane.querySelector('#' + pfx + '-g-' + id); };
    var volEl = function () { return bcForm.querySelector('[data-volume]'); };
    var radioVal = function (name) { var r = bcForm.querySelector('input[name="' + name + '"]:checked'); return r ? r.value : null; };

    var saveBC = function () {
      try {
        sessionStorage.setItem(BC_KEY, JSON.stringify({
          volume: volEl() ? volEl().value : '',
          delivery: radioVal('delivery'),
          payment: radioVal('payment'),
          name: fld('name') ? fld('name').value : '',
          email: fld('email') ? fld('email').value : '',
          org: fld('org') ? fld('org').value : '',
          role: fld('role') ? fld('role').value : '',
          csv: pane.__giftCsvRows || null,
          csvName: pane.__giftCsvName || null
        }));
      } catch (e) {}
    };

    var restoreBC = function () {
      var s; try { s = JSON.parse(sessionStorage.getItem(BC_KEY) || 'null'); } catch (e) { s = null; }
      if (!s) return;
      if (s.volume && volEl()) volEl().value = s.volume;
      if (s.delivery) { var d = bcForm.querySelector('input[name="delivery"][value="' + s.delivery + '"]'); if (d) d.checked = true; }
      if (s.payment) { var p = bcForm.querySelector('input[name="payment"][value="' + s.payment + '"]'); if (p) p.checked = true; }
      ['name', 'email', 'org', 'role'].forEach(function (k) { var el = fld(k); if (el && s[k]) el.value = s[k]; });
      // Re-attach the CSV (parsed rows) + re-render its preview.
      if (s.csv && s.csv.length) {
        pane.__giftCsvRows = s.csv; pane.__giftCsvName = s.csvName;
        var drop = pane.querySelector('.t-drop');
        var fileInput = drop && drop.querySelector('input[type="file"]');
        if (drop && fileInput) renderCsv(drop, s.csvName || 'your-list.csv', { rows: s.csv, errors: [] }, fileInput);
      }
      // Nudge dependent UI (volume total, bearer echo, delivery-driven panels).
      if (volEl()) volEl().dispatchEvent(new Event('input', { bubbles: true }));
      var cd = bcForm.querySelector('input[name="delivery"]:checked'); if (cd) cd.dispatchEvent(new Event('change', { bubbles: true }));
    };

    bcForm.addEventListener('input', saveBC);
    bcForm.addEventListener('change', saveBC);
    restoreBC();
  })();
})();
